import { exportToWord } from '../utils/exportToWord'; // Import the export function
import './PolicyStyles.css'; // Ensure the correct path to your CSS file

const AntiBriberyAndCorruptionPolicy = ({ clientName, clientAddress, effectiveDate,  companyNumber, }) => {
  return (
    <div className="policy-container">
      <h3 className="policy-title">Accident & Incident Management Policy</h3>
      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> { companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">Policy Statement</h4>
      <p className="section-content">
        This policy sets out the company's commitment to preventing bribery and corruption in all its forms. The company strives to maintain the highest standards of integrity and ethics in its business activities and expects its employees, contractors, and third parties to act honestly and transparently.
      </p>

      <h4 className="section-title">Purpose</h4>
      <p className="section-content">
        The purpose of this policy is to ensure that the company, its employees, and partners are not involved in bribery or corruption in any form. This policy defines bribery and corruption, sets out the company's expectations, and provides guidance on how to identify and report bribery and corruption.
      </p>

      <h4 className="section-title">Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, third-party vendors, and agents working with the company, across all locations and jurisdictions. The company also expects its partners, clients, and suppliers to comply with this policy.
      </p>

      <h4 className="section-title">Definition of Bribery and Corruption</h4>
      <p className="section-content">
        Bribery is offering, giving, receiving, or soliciting something of value to influence actions or decisions. Corruption is the abuse of power for personal gain, which includes bribery, fraud, and misappropriation of assets.
      </p>

      <h4 className="section-title">Responsibilities</h4>
      <p className="section-content"><strong>Employees:</strong> All employees are required to comply with this policy, and to report any suspected instances of bribery or corruption promptly.</p>
      <p className="section-content"><strong>Managers:</strong> Managers must ensure that their teams understand and comply with this policy, and are responsible for preventing bribery and corruption within their areas of responsibility.</p>
      <p className="section-content"><strong>Third-Party Vendors:</strong> The company expects all third-party vendors and agents to comply with this policy. Contracts with vendors should contain clauses prohibiting bribery and corruption.</p>

      <h4 className="section-title">Prohibited Activities</h4>
      <p className="section-content">
        The following actions are strictly prohibited under this policy:
      </p>
      <ul>
        <li>Offering, giving, or receiving bribes in any form.</li>
        <li>Offering gifts or hospitality with the intention of influencing a business decision.</li>
        <li>Facilitating payments to influence decisions or actions.</li>
        <li>Engaging in fraudulent or corrupt activities for personal or business gain.</li>
      </ul>

      <h4 className="section-title">Gifts and Hospitality</h4>
      <p className="section-content">
        The company allows modest and appropriate gifts or hospitality in the course of business, provided they are not intended to influence decisions or actions. However, employees must report any gifts or hospitality offered or received above a certain threshold to their manager.
      </p>

      <h4 className="section-title">Reporting Bribery or Corruption</h4>
      <p className="section-content">
        Employees are encouraged to report any suspicious activity related to bribery or corruption. Reports can be made confidentially and anonymously through the company's whistleblowing system. All reports will be investigated, and any employee found in violation of this policy will be subject to disciplinary action.
      </p>

      <h4 className="section-title">Investigation</h4>
      <p className="section-content">
        The company will investigate any allegations of bribery or corruption thoroughly and in accordance with its disciplinary procedures. Employees are required to cooperate fully with any investigation.
      </p>

      <h4 className="section-title">Corrective Actions</h4>
      <p className="section-content">
        If a violation of this policy is found, the company will take corrective actions. These may include disciplinary actions, termination of employment or contracts, and legal action if necessary.
      </p>

      <h4 className="section-title">Training and Awareness</h4>
      <p className="section-content">
        The company will provide regular training to employees to ensure they understand the risks of bribery and corruption and how to comply with this policy. New employees will be briefed on this policy during their induction process.
      </p>

      <h4 className="section-title">Record Keeping</h4>
      <p className="section-content">
        The company will maintain accurate records of all transactions, gifts, and hospitality to ensure transparency and compliance with this policy.
      </p>

      <h4 className="section-title">Review and Monitoring</h4>
      <p className="section-content">
        This policy will be reviewed annually, and its implementation will be monitored by the senior management team. The company will ensure that it continues to comply with relevant laws and regulations, and that the policy remains effective in preventing bribery and corruption.
      </p>

      <h4 className="section-title">Conclusion</h4>
      <p className="section-content">
        The company is committed to maintaining a business environment free from bribery and corruption. All employees and third parties are expected to comply with this policy, which forms a critical part of our ethical and legal obligations.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I have read, understood, and agree to comply with the Anti-Bribery and Corruption Policy. I understand my responsibilities to report any incidents of bribery or corruption, and to cooperate with any investigations.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is hereby in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>
    </div>
  );
};

export default AntiBriberyAndCorruptionPolicy;
